import ExtrasInsurance from './ExtrasInsurance';

export default ExtrasInsurance;
